import { render, staticRenderFns } from "./A-1-1_AboutUs_BrandMessaging.vue?vue&type=template&id=7deb52f8&"
import script from "./A-1-1_AboutUs_BrandMessaging.vue?vue&type=script&lang=js&"
export * from "./A-1-1_AboutUs_BrandMessaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports